import React, { createContext, useContext, useState } from 'react';

/**
 * Global app-level context.
 * Extend AppState and AppContextValue as the app grows.
 */
interface AppState {
    // e.g. theme: 'light' | 'dark';
}

interface AppContextValue {
    state: AppState;
    // e.g. setTheme: (theme: 'light' | 'dark') => void;
}

const AppContext = createContext<AppContextValue | undefined>(undefined);

export function AppProvider({ children }: { children: React.ReactNode }) {
    const [state] = useState<AppState>({});

    return (
        <AppContext.Provider value={{ state }}>
            {children}
        </AppContext.Provider>
    );
}

export function useAppContext(): AppContextValue {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
}
